@if (!conversation()) {
	<div class="empty-conversation">
		<div class="empty-icon">
			<mat-icon>forum</mat-icon>
		</div>
		<p class="empty-title">Select a conversation</p>
		<p class="empty-subtitle">Choose one from the list or create a new one</p>
	</div>
} @else {
	<div class="view-header">
		<div class="conv-avatar" [class.broadcast]="conversation()!.type === 'BROADCAST'">
			<mat-icon>{{ conversation()!.type | conversationTypeIcon }}</mat-icon>
		</div>
		<div class="header-info">
			<h2>{{ conversation()!.type | conversationTypeLabel }}</h2>
		</div>
		<div class="header-actions">
			<button mat-icon-button class="header-btn" matTooltip="Mark as read" (click)="markAsRead()">
				<mat-icon>done_all</mat-icon>
			</button>
			<button mat-icon-button class="header-btn" matTooltip="Refresh" (click)="refresh.emit()" [disabled]="isLoading()">
				<mat-icon>refresh</mat-icon>
			</button>
		</div>
	</div>

	<ul class="message-list" #messageList>
		@if (isLoading()) {
			<li class="spinner-row">
				<mat-spinner diameter="32" />
			</li>
		} @else if (messages().length === 0) {
			<li class="empty-messages">
				<mat-icon>chat_bubble_outline</mat-icon>
				<span>No messages yet</span>
			</li>
		} @else {
			@for (msg of messages(); track msg.messageUuid) {
				<li class="message-row">
					<div class="bubble">
						<span class="bubble-sender">{{ msg.senderName }}</span>
						<p class="bubble-content">{{ msg.content }}</p>
						<div class="bubble-footer">
							<time class="bubble-time">{{ msg.sentAt | formatChatTime }}</time>
						</div>
					</div>
					@if (msg.receipts.length > 0) {
						<ul class="receipt-list">
							@for (receipt of msg.receipts; track receipt.deviceName) {
								<li class="receipt-item" [ngClass]="receiptStatusClass(receipt.status)">
									<span class="receipt-dot"></span>
									<span class="receipt-text">{{ receipt.deviceName }}</span>
									<span class="receipt-status">{{ receipt.status }}</span>
								</li>
							}
						</ul>
					}
				</li>
			}
		}
	</ul>

	<div class="input-area">
		<mat-form-field appearance="outline" class="input-field">
			<textarea
				matInput
				[formControl]="messageControl"
				placeholder="Write a message..."
				cdkTextareaAutosize
				cdkAutosizeMinRows="1"
				cdkAutosizeMaxRows="4"
				(keydown)="handleEnterKey($event)"
			></textarea>
		</mat-form-field>
		<button
			mat-fab
			class="send-btn"
			[disabled]="!messageControl.valid || isSending()"
			(click)="sendMessage()"
		>
			<mat-icon>{{ isSending() ? 'hourglass_empty' : 'send' }}</mat-icon>
		</button>
	</div>
}
